import React from 'react';
import { Table, Tag, Button, Icon, Popover } from 'antd';
import AntSelect, { AntOption } from '../AntSelect';
import * as Func from '../../../../../helpers/functions';
import { isEqual, groupBy } from 'lodash';
import './styles.less';

class TagSearch extends React.Component {

    state = {
        columns: [
            {
                title: 'Tag tìm kiếm',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                render: (name, record)=>{
                    return (
                        record.tagGroup.name && <span className={`${record.tagGroup.type === 'special' ? "fw-600" : ''}`}>{record.tagGroup.name}</span>
                    )
                }
            },
            {
                title: this.props.t('item.tagSearch.tags'),
                dataIndex: 'tag',
                key: 'tag',
                width: 500,
                render: (tag, record, index)=> {
                    let textTmp = record.tagList && (record.tagList || []).filter(item => item.isInsert).map((item, idx) => 
                        <Tag key={idx} closable onClose={(e)=> this.closeTag(e, record.index, item.id, record.tagList)} color="#2269A6">{item.tagI18n[0].name}</Tag>)
                    if(record.tagGroup.type === 'special'){
                        textTmp = <div className="title-tags">{record.tagGroup.tag}</div>
                    }
                    return textTmp;
                }
                    
            },
            {
                title: '',
                dataIndex: 'action',
                key: 'action',
                width: 50,
                render: (value, record, index)=> {
                    const { tagGroupDetailState } = this.props;
                    const { tagGroupDetails } = tagGroupDetailState;
                    const valueTags = (record.tagList || []).filter(item => item.isInsert === true).map(item => item.id)
                    const ListTag = ()=>{
                        return(
                            <div className="action-tag-search">
                                <AntSelect
                                    showArrow
                                    mode="multiple"
                                    suffixIcon={<Icon type="search" />}
                                    filterOption={this.selectFilterSearch}
                                    value={ valueTags }
                                    onChange={ tags => this.onChangeTag(tags, tagGroupDetails, record.index) }
                                    style={{width: '100%'}}
                                >
                                    { (tagGroupDetails || []).map(tag => (
                                        <AntOption key={ tag.id } value={ tag.id }>
                                            { tag.name }
                                        </AntOption>
                                    )) }
                                </AntSelect>
                            </div>
                        )
                    }
                    return (
                        record.tagGroup.type !== 'special' && <Popover
                            content={<ListTag />}
                            title=""
                            trigger="click"
                            placement="bottomRight"
                            visible={this.state.visibleIndex === index}
                            onVisibleChange={(visible)=> this.handleVisibleChange(visible, index)}
                        >
                            <Button onClick={()=>this.onLoadTag(record.tagGroup.id)} type="primary" shape="circle" icon="plus" />
                        </Popover>
                    )
                }
            },
        ],
        visibleIndex: null,
        arrData: [],
        deleteTags: []
    }

    componentDidUpdate(prevProps) {
        if (this.props.tagSKUs && !isEqual(this.props.tagSKUs, prevProps.tagSKUs)) {
            const groupedData = groupBy(this.props.tagSKUs, tagSKU => tagSKU.tagGroup.type);
            const groupedDataTmp = Object.keys(groupedData).map(tagGroupTypeId => {
                return [
                    {
                        tagGroup: {
                            id: tagGroupTypeId,
                            tag: tagGroupTypeId === '1' ? 'Tags' : '',
                            name: this.props.t(`item.tagSearch.tagGroupTypes.${tagGroupTypeId}`),
                            type: 'special'
                        },
                    },
                    ...groupedData[tagGroupTypeId]
                ]
            })
            this.setState({arrData: [].concat.apply([], groupedDataTmp || [])});
        }
    }

    handleVisibleChange = (visible, index) => {
        this.setState({ visibleIndex: visible ? index : null });
    };
      
    closeTag = (e, index, id, tags)=>{
        e.preventDefault();
        if(tags){
            const idx = tags.findIndex(item => item.id === id);
            tags[idx].isInsert = false
            this.props.onAddTagGroup(tags, index);
        }
    }

    onChangeTag = (value, tags, index)=>{
        let tmpArr = [];
        if(tags.length > 0){
            tmpArr = (value || []).map(item => {
                const tagSelect = tags.find(i => i.id === item)
                return {
                    id: item,
                    isInsert: true,
                    tagI18n: [
                        {
                            name: tagSelect.name
                        }
                    ]
                }
            })
        }
        this.props.onAddTagGroup(tmpArr, index);
    }

    onLoadTag = (id)=>{
        this.props.loadDataTagGroup(id);
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props?.children?.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    render() {
        const { columns, arrData } = this.state;
        return (
            <Table
                {...this.props}
                bordered 
                columns={columns}
                rowKey={(record, k) => record.tagGroup.id ? record.tagGroup.id : k}
                dataSource={arrData}
                pagination={false}
                size="small"
                className="table-tag-search"
                showHeader={false}
                // rowClassName={(record, index) => record.tagGroup.type === 'special' ? 'table-row-light' :  ''}
            />
        )
    }

}
export default TagSearch;